module.exports = __webpack_public_path__ + "static/media/radiopublic-flag-red-32px.909bc9bf.svg";